import React from "react";
import FlexWrapper from "../../../styles/shared/FlexWrapper";
import {
  TableContainer,
  TableHeaderTitle,
  TableRowItem
} from "../styles/resultsStyles";

const TableHeader = () => {
  return (
    <TableContainer padding="2rem 10rem">
      <FlexWrapper alignItems="center" wrap="wrap">
        <TableRowItem>
          <TableHeaderTitle>Ośrodek</TableHeaderTitle>
        </TableRowItem>
        <TableRowItem>
          <TableHeaderTitle>Adres</TableHeaderTitle>
        </TableRowItem>
        <TableRowItem>
          <TableHeaderTitle>Dane kontaktowe</TableHeaderTitle>
        </TableRowItem>
      </FlexWrapper>
    </TableContainer>
  );
};

export default TableHeader;
